import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar } from '@mui/material';
// routes
import { PATH_AUTH, PATH_DASHBOARD } from '../../../routes/paths';
// auth
import { useAuthContext } from '../../../auth/hooks';
// components
import { useSnackbar } from '../../../components/snackbar';
import CustomPopover from '../../../components/custom-popover';
import { IconButtonAnimate } from '../../../components/animate';

import { useLocales } from '../../../locales';
import { routePrefix } from 'src/utils/methods/StandardMethods';
import React from 'react';
import { ROLES } from 'src/utils/constants/constants';
// ----------------------------------------------------------------------

const ADMIN_OR_INDIUSER_OPTIONS = (routePrefix: string) => {
  return ([
    // {
    //   label: 'Home',
    //   linkTo: PATH_DASHBOARD.dashboard.dash(routePrefix),
    // },
    // {
    //   label: 'View API Keys',
    //   linkTo: `/${routePrefix}/app/api-keys`,
    // },
    // {
    //   label: 'View Encryption Keys',
    //   linkTo: `/${routePrefix}/app/encryption-keys`,
    // },
    {
      label: 'Account Settings',
      linkTo: PATH_DASHBOARD.accountSettings.settings(routePrefix),
    },
  ]
  )
}

const OPTIONS = (routePrefix: string) => {
  return (
    [
      // {
      //   label: 'Home',
      //   linkTo: PATH_DASHBOARD.dashboard.dash(routePrefix),
      // },
      {
        label: 'Account Settings',
        linkTo: PATH_DASHBOARD.accountSettings.settings(routePrefix),
      },
    ]
  )
}

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const { translate } = useLocales();

  const { user, logout } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleLogout = async () => {
    try {
      logout();
      navigate(PATH_AUTH.login, { replace: true });
      handleClosePopover();
    } catch (error) {
      console.error(error);
      enqueueSnackbar(translate('Unable to logout!'), { variant: 'error' });
    }
  };

  const handleClickItem = (path: string) => {
    handleClosePopover();
    navigate(path);
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={user?.profileImage || '/assets/avatar/avatar_25.jpg' || user?.firstname} alt={user?.firstname} sx={{ height: 30, width: 30 }} />
      </IconButtonAnimate>

      <CustomPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {user?.firstname + " " + user?.lastname}
          </Typography>
          <Typography variant="subtitle2" noWrap>
            {translate(user?.role?.name)}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {((user?.role.name === ROLES.ORG_ADMIN || user?.role.name === ROLES.INDIVIDUAL_USER) ? ADMIN_OR_INDIUSER_OPTIONS(routePrefix(user)) : OPTIONS(routePrefix(user))).map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {translate(option.label)}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={handleLogout}
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          {translate('Logout')}
        </MenuItem>
      </CustomPopover>
    </>
  );
}
